import React from 'react';
import { Accordion, Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import Footer from '../../Layout/Footer';
import Header from '../../Layout/Header';
import bankdetails from '../../../assets/img/bank-account-details.jpg';
import { FiFileText } from 'react-icons/fi';
import { BiCreditCardFront } from 'react-icons/bi';
import { BsCreditCard } from 'react-icons/bs';
import { RiHandCoinLine } from 'react-icons/ri';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { getCountryDropdown, getStateDropdown, updateSignUpBankDetails } from '../../../Redux/User/action';
import axios from 'axios';
import { useEffect } from 'react';
import { useState } from 'react';
import loader from '../../../assets/img/loader.gif';


const BankAccountDetailsSignUp = () => {

    const navigate = useNavigate();
    const [isverified, setIsverified] = useState(false);
    const [countries, setCountries] = useState();
    const [states, setStates] = useState();
    const [isloader, setIsloader] = useState(false);
    useEffect(() => {
        getCountryDropdown()((response) => {
            if (response && response.status) {
                setCountries(response?.data)
            }
        });
    }, []);
    const validationSchema = Yup.object().shape({

        pan_number: Yup.string()
            .required('Password is mandatory'),

        account_name: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid Account Name')
            .required('Required'),
        ifsc_code: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid IFSC Code')
            .required('Required'),
        account_number: Yup.string()
            .matches(/^[0-9]+$/, 'Enter a valid Account Number')
            .required('Required'),
        consultation_call: Yup.number()
            .typeError("Enter a valid number")
            .required('Required'),
        consultation_chat: Yup.number()
            .typeError("Enter a valid number")
            .required('Required'),
        // service_min_charge: Yup.string()
        //     .required('Required'),
        // service_max_charge: Yup.string()
        //     .required('Required'),
        // GSTIN: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid GST')
        //     .required('Required'),
        // name: Yup.string().matches(/^[a-zA-Z0-9 ]+$/, 'Enter a valid Name')
        //     .required('Required'),
        // GSTAddress: Yup.string()
        //     .required('Required'),
        // location: Yup.string()
        //     .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            pan_number: "",
            pan_verified: "true",
            account_name: "",
            ifsc_code: "",
            account_number: "",
            consultation_call: "",
            consultation_chat: "",
            // service_min_charge: "",
            // service_max_charge: "",
            GSTIN: "",
            name: "",
            GSTAddress: "",
            location: "",

        },
        validationSchema,
        onSubmit: (values) => {

            setIsloader(true)
            updateSignUpBankDetails(values)((response) => {
                if (response && response.status) {
                    setIsloader(false)
                    navigate('/addressdetails')
                }
                else {
                    setIsloader(false)
                }
            });
        },
    });
    const onCheckPan = () => {
        const token = process.env.REACT_APP_ATTESTR_TOKEN;
        axios.post('https://api.attestr.com/api/v1/public/checkx/pan',
            {
                pan: formik.values?.pan_number?.toUpperCase(),

            },
            {
                withCredentials: true,
                headers: { authorization: `Basic ${token}` },
            }
        )
            .then(function (response) {

                if (response?.data?.valid) {
                    setIsverified(true)
                }
            })
            .catch(function (error) {

            });
    }
    const getState = (e) => {
        getStateDropdown(e.target.value)((response) => {
            if (response && response.status) {
                setStates(response?.data)
            }
        });
    }
    return (
        <React.Fragment>
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>
                                    Add Bank Account Details </h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name"> Add Bank Account Details</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="bank-account-details">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <img src={bankdetails} alt="" className="img-fluid" />
                        </div>
                        <div className="col-lg-6">
                            <div className="bank-account-details-form">
                                <Form onSubmit={formik.handleSubmit}>
                                    <Accordion defaultActiveKey="0" flush>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header><FiFileText color='#1bbaed' size={25} className='me-2' /> Pan number</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Pan number <span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <div className='d-flex align-content-center'>
                                                        <Form.Control
                                                            type="text"
                                                            name='pan_number'
                                                            onChange={formik.handleChange}
                                                            maxLength={10}
                                                            placeholder="Enter Your Pan Number"
                                                            required
                                                            style={{ textTransform: "uppercase" }}
                                                        />
                                                        {!isverified ?
                                                            <button type="button" class="verify-btn ms-2" onClick={() => onCheckPan()}>Verify</button>
                                                            :
                                                            <button type="button" class="verified-btn ms-2">Verified</button>
                                                            // <i className="bi bi-check" style={{ fontSize: "28px", color: "#00FF00" }}></i>
                                                        }
                                                        {/* <button type="button" class="btn btn-light ms-2"> <FiCheckCircle color='#1bbaed' size={25} className='me-2' /></button> */}
                                                    </div>
                                                    <Form.Control.Feedback type="invalid">{formik.errors.pan_number}</Form.Control.Feedback>
                                                </Form.Group>

                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header><BiCreditCardFront color='#1bbaed' size={25} className='me-2' /> Provide Bank Account Details </Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label> Account Name<span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='account_name'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.account_name && !formik.errors.account_name}
                                                        isInvalid={!!formik.errors.account_name}
                                                        maxLength={30}
                                                        placeholder="Enter Your Account Name"
                                                        required

                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.account_name}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label> IFSC Code<span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='ifsc_code'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.ifsc_code && !formik.errors.ifsc_code}
                                                        isInvalid={!!formik.errors.ifsc_code}
                                                        maxLength={15}
                                                        placeholder="Enter Your IFSC Code"
                                                        required
                                                        style={{ textTransform: "uppercase" }}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.ifsc_code}</Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label> Account Number<span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='account_number'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.account_number && !formik.errors.account_number}
                                                        isInvalid={!!formik.errors.account_number}
                                                        maxLength={30}
                                                        placeholder="Enter Your Account Number"
                                                        required
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.account_number}</Form.Control.Feedback>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header><BiCreditCardFront color='#1bbaed' size={25} className='me-2' /> Consultation Charges per Minutes</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label> For Call(In Rupees)<span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='consultation_call'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.consultation_call && !formik.errors.consultation_call}
                                                        isInvalid={!!formik.errors.consultation_call}
                                                        placeholder=""
                                                        required
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.consultation_call}</Form.Control.Feedback>

                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label> For Chat(In Rupees)<span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='consultation_chat'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.consultation_chat && !formik.errors.consultation_chat}
                                                        isInvalid={!!formik.errors.consultation_chat}
                                                        placeholder=""
                                                        required
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.consultation_chat}</Form.Control.Feedback>
                                                </Form.Group>

                                            </Accordion.Body>
                                        </Accordion.Item>
                                        {/* <Accordion.Item eventKey="3">
                                            <Accordion.Header><BsCreditCard color='#1bbaed' size={25} className='me-2' /> Add Cost</Accordion.Header>
                                            <Accordion.Body>
                                                <div className='add-cost'>
                                                    <div className=''>
                                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                                            <Form.Label> Primary Servcies<span style={{ color: "#db3131" }}>*</span></Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name='service_min_charge'
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.service_min_charge && !formik.errors.service_min_charge}
                                                                isInvalid={!!formik.errors.service_min_charge}
                                                                placeholder="5000 Rs"
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.service_min_charge}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                    <div className='add-cost-to'>
                                                        <p>to</p>
                                                    </div>
                                                    <div className=''>
                                                        <Form.Group className="mb-3" controlId="formBasicEmail">
                                                            <Form.Control
                                                                className='mt-4'
                                                                type="text"
                                                                name='service_max_charge'
                                                                onChange={formik.handleChange}
                                                                isValid={formik.touched.service_max_charge && !formik.errors.service_max_charge}
                                                                isInvalid={!!formik.errors.service_max_charge}
                                                                placeholder="10000 Rs"
                                                                required
                                                            />
                                                            <Form.Control.Feedback type="invalid">{formik.errors.service_max_charge}</Form.Control.Feedback>
                                                        </Form.Group>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </Accordion.Item> */}
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header><RiHandCoinLine color='#1bbaed' size={25} className='me-2' /> Add GST</Accordion.Header>
                                            <Accordion.Body>
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>GSTIN</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='GSTIN'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.GSTIN && !formik.errors.GSTIN}
                                                        isInvalid={!!formik.errors.GSTIN}
                                                        maxLength={15}
                                                        placeholder="Enter GSTIN"
                                                        style={{ textTransform: "uppercase" }}
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.GSTIN}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                                    <Form.Label>Name </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='name'
                                                        onChange={formik.handleChange}
                                                        isValid={formik.touched.name && !formik.errors.name}
                                                        isInvalid={!!formik.errors.name}
                                                        placeholder="Enter Name"
                                                    />
                                                    <Form.Control.Feedback type="invalid">{formik.errors.name}</Form.Control.Feedback>
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                                    <Form.Label>Address </Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name='GSTAddress'
                                                        onChange={formik.handleChange}
                                                        placeholder="Enter Address"
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                                    <Form.Label>Country </Form.Label>
                                                    <Form.Select aria-label="Default select example" name='location' onChange={(e) => getState(e)}>
                                                        <option value="">Select Country</option>
                                                        {countries?.map(country =>
                                                            <option value={country?.id}>{country?.country_name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                                <Form.Group className="mb-3" controlId="formBasicPassword">
                                                    <Form.Label>State </Form.Label>
                                                    <Form.Select aria-label="Default select example" name='location' onChange={formik.handleChange}>
                                                        <option value="">Select State</option>
                                                        {states?.map(state =>
                                                            <option value={state?.id}>{state?.state_name}</option>
                                                        )}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>

                                    <div className="userdetails-form-btn">
                                        {isloader == true ?
                                            <div className='loader'>
                                                <img src={loader} alt="" />
                                            </div>
                                            :
                                            <Button type="submit" className="btn btn-primary next-btn mt-3 mb-3">Continue</Button>
                                        }
                                    </div>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default BankAccountDetailsSignUp;